<template>
  <div class="MissionArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('specificExtraWorkDetails')">
        <v-row class="pa-2">
          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("PageNo") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.PAGENO }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestedPersonName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.PersonName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.RecDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("LastChangeDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.LastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col cols="3">{{ $t("status") }}:</v-col>
              <v-col cols="9">
                <span
                  class="text-value"
                  v-text="
                    vacation.Statustype +
                    '-' +
                    (details.IsTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("periodOrMonth") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.Period }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("description") }}:</v-col>
              <v-col cols="9">
                <span class="text-value">
                  {{ details.PersonName }}:{{ details.Dscp }} <br />
                  <span>تائید / رد کننده: {{ details.RejectCommand }}</span>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn small v-if="visibleReturn" @click="ReturnRequest">{{
            $t("ReturnRequest")
          }}</v-btn>

          <v-btn small v-if="visibleApprove" @click="ApproveRequest">{{
            $t("ApproveRequest")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          :pageNo="details.PAGENO + ''"
          :pageType="5"
          :year="Number(vacation.Year)"
        />
      </box>
    </v-dialog>
  </div>
</template>

<script>
import RequestState from "@/model/RequestState";
import ArchiveDetalsFlow from "../../request/ArchiveDetalsFlow.vue";

const initialData = () => {
  return {
    visible: false,
    vacation: "",
    details: "",
    visibleEdit: false,
    visibleDelete: false,
    visibleReturn: false,
    visibleApprove: false,
    ApprovedPerson: "",
  };
};

export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return initialData();
  },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
    },
    show(vacation, details) {
      this.resetData();
      this.visible = true;
      this.vacation = vacation;
      this.details = details;
      this.checkActionsVisiblity();
    },
    hide() {
      this.visible = false;
    },

    checkActionsVisiblity() {
      this.visibleEdit = true;
      this.visibleDelete = true;
      this.visibleReturn = true;
      this.visibleApprove = true;
      ////console.log(String.fromCharCode(1740));
      ////console.log(String.fromCharCode(1610));
      /*this.visibleEdit = false;
      this.visibleDelete = false;

      switch (this.vacation.Status) {
        case 0: //darkhost avaliyeh
        case 1: //bargasht khordeh
        case 2: //ersal mojadad
        case 4: //rad shodeh
          //btnPrint.Visible = false;
          this.visibleEdit = true;

          if (this.vacation.Status == 1) {
            //emkan hazfe darkhoste rad shodeh
            this.visibleDelete =
              this.$store.state.personel.personelDetail.Permission[15].toString() ==
              "1";
          } else {
            this.visibleDelete = true;
          }
      }*/
    },
    ReturnRequest() {
      this.operationOnRequest(RequestState.RequestState.Return);
    },
    ApproveRequest() {
      this.operationOnRequest(RequestState.RequestState.Approve);
    },
    operationOnRequest(requestState) {
      var list = [this.vacation];
      this.$emit("operationOnRequest", requestState, list);
      this.hide();
    },
  },
};
</script>

<style scoped>
*td {
  padding: 2px;
}
</style>